export const listUrl = '/channel/list'
export const createUrl = '/channel/create'
export const updateUrl = '/channel/update'
export const deleteUrl = '/channel/delete'
export const exportUrl = '/channel/export'
export const obdListUrl = '/channel/{0}/obd/list'
export const obdUnauthorizedListUrl = '/channel/{0}/obd/unauthorized/list'
export const addObdUrl = '/channel/{0}/obd'
export const deleteObdUrl = '/channel/{0}/obd'

export const resetPwdUrl = '/company/reset/{0}'
export const importObdUrl = process.env.VUE_APP_BASEURL + '/channel/{0}/obdBindingImport'
export const exportObdUrl = '/channel/obdBindingExport'

import request from '@/utils/request'

function getChannelList() {
    return request({
      url: '/channel/list',
      method: 'get'      
    })
}
export {
    getChannelList
}